<template>
  <div>
    <div
      @click="open()"
      class="shadow-card"
      :style="{ cursor: 'pointer', padding: 0 }"
    >
      <div>
        <div v-if="article.is_main_article" class="main-article-tag">
          <img
            src="../../../../assets/images/resources-main-article-tag.svg"
            alt="main_article_tag"
            style="margin: auto"
            width="58px"
            height="85px"
            class="main-img"
          />
        </div>
        <img
          :src="
            article.article_attach
              ? article.article_attach.file
                ? article.article_attach.file
                : article.article_attach
              : 'https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/no-image.png'
          "
          class="article-image"
          alt="article_image"
        />
      </div>
      <div :style="{ marginLeft: '16px', marginTop: '24px' }">
        <div class="article-tag" :style="{ background: getPrimary50Color() }">
          <font-awesome-icon
            size="sm"
            class="mr-1"
            :style="{ color: getPrimaryColor() }"
            :icon="['fas', 'book-open']"
          />
          <p class="article-tag-text" :style="{ color: getPrimaryColor() }">
            Article
          </p>
        </div>
      </div>
      <p class="article-title">{{ article.article_title }}</p>
      <p class="article-description-container">
        <span
          v-html="getLimitedDescription(article.article_description)"
          class="article-description"
        ></span>
      </p>
      <div class="article-link">
        <span :style="{ color: getPrimaryColor() }">Read more</span>
      </div>
    </div>
  </div>
</template>

<script>
import SocialSharingModal from "../../../Modals/SocialSharing";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faBookOpen);

export default {
  name: "ArticleTabView",
  components: {
    SocialSharingModal
  },
  props: {
    articleData: Object
  },
  data() {
    return {
      article: null
    };
  },

  created() {
    this.article = this.articleData;
  },

  methods: {
    open() {
      // this.$router.push({ name: 'ResourceView', params: {type: 'article', id: this.article.id} })
      this.markAsClicked(7, 4, this.article.id);
      window.open(
        `${process.env.SSO_BASE_URL}${this.article.article_share}`,
        "_blank"
      );
    },
    /**
     * Limit description text limit
     *
     * @param {String} description
     */
    getLimitedDescription(description) {
      const div = document.createElement("div");
      div.innerHTML = description;
      const text = div.textContent || div.innerText || "";

      return text.length > 150 ? text.substring(0, 150) + "..." : text;
    }
  }
};
</script>

<style lang="scss" scoped>
.article-image {
  width: 100%;
  height: 424px;
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
  object-fit: contain;
  @media only screen and (max-width: 700px) {
    height: 165px;
  }
}

.main-article-tag {
  position: absolute;
  z-index: 1;
  width: 87px;
  height: 97px;
  background: #ffffff;
  border-radius: 0px 0px 16px 16px;
  text-align: center;
  margin-top: 16px;
  margin-left: 32px;
  @media only screen and (max-width: 700px) {
    margin-left: 21px;
    width: 70px;
    height: 77.33px;
  }
  .main-img {
    @media only screen and (max-width: 700px) {
      transform: scale(0.8);
    }
  }
}

.article-tag-background {
  width: 70px;
  height: 22px;
  border-radius: 4px;
  opacity: 0.3;
}

.article-tag {
  padding: 0px 8px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

.article-tag-text {
  font-family: "Lato";
  font-weight: 700;
  font-size: 12px;
  text-align: center;
  margin-bottom: 0;
  margin-left: 4px;
}

.article-title {
  font-family: "Lato";
  font-weight: 700;
  font-size: 20px;
  color: #000000;
  padding-top: 8px;
  margin: 0px;
  line-height: 30px;
  margin-left: 16px;
  margin-right: 16px;
}

.article-description {
  font-family: "Lato";
  font-weight: 400;
  font-size: 16px;
  color: #647490;
  line-height: 32px;
}

.article-description-container {
  padding-top: 8px;
  padding-bottom: 16px;
  margin: 0px 16px;
}

.article-link {
  font-family: "Lato";
  font-weight: 400;
  font-size: 14px;
  text-align: end;
  cursor: pointer;
  margin-right: 16px;
  padding-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/resources/previews/ArticleCard.vue